import { render } from "./preview.vue?vue&type=template&id=5356e8df"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"

import exportComponent from "/data/build/bruenor/tmp-docuseal/webpack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__